"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MonthEnum = void 0;
// export interface DateRangeType {
//   from: Date;
//   to: Date;
// }
// export type PartialDateRangeType = {
//   [K in keyof DateRangeType]?: DateRangeType[K] | null;
// };
var MonthEnum;
exports.MonthEnum = MonthEnum;

(function (MonthEnum) {
  MonthEnum[MonthEnum["JANUARY"] = 0] = "JANUARY";
  MonthEnum[MonthEnum["FEBRUARY"] = 1] = "FEBRUARY";
  MonthEnum[MonthEnum["MARCH"] = 2] = "MARCH";
  MonthEnum[MonthEnum["APRIL"] = 3] = "APRIL";
  MonthEnum[MonthEnum["MAY"] = 4] = "MAY";
  MonthEnum[MonthEnum["JUNE"] = 5] = "JUNE";
  MonthEnum[MonthEnum["JULY"] = 6] = "JULY";
  MonthEnum[MonthEnum["AUGUST"] = 7] = "AUGUST";
  MonthEnum[MonthEnum["SEPTEMBER"] = 8] = "SEPTEMBER";
  MonthEnum[MonthEnum["OCTOBER"] = 9] = "OCTOBER";
  MonthEnum[MonthEnum["NOVEMBER"] = 10] = "NOVEMBER";
  MonthEnum[MonthEnum["DECEMBER"] = 11] = "DECEMBER";
})(MonthEnum || (exports.MonthEnum = MonthEnum = {}));